// extracted by mini-css-extract-plugin
export default {"logoDiv":"Logo_logoDiv__EJdw8","logoImg":"Logo_logoImg__WAEKF","logoText":"Logo_logoText__retJ4","a":"Logo_a__ggAqC"};